export enum AccountPageId {
	AccountDetails = 'account-details',
	ChangePassword = 'change-password',
	RewardOffers = 'reward-offers',
	Vehicles = 'my-vehicles',
}
